import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create } from '~/actions/articles';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      image: '',
      description: '',
      upc: '',
      weight: 0,
      price: 0,
    };
  }

  submit() {
    create(this.props.dispatch, this.context.apiClient, this.state)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Input label="Name" required value={this.state.name} onChange={name => this.setState({ name })} />
              <Input label="Image (url)" value={this.state.image} onChange={image => this.setState({ image })} />
              <Input label="Description" multiline value={this.state.description} onChange={description => this.setState({ description })} />
              <Input label="Weight (grams)" type="number" value={this.state.weight} onChange={weight => this.setState({ weight: parseInt(weight, 10) })} />
              <Input label="UPC" value={this.state.upc} onChange={upc => this.setState({ upc })} />
              <Input label="Price" value={this.state.price} onChange={price => this.setState({ price })} />
              <Button label="Create" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ArticleNew/index.js